import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpClient from "../helpers/httpClient";

const initialState = {
  ingredients: {
    data: [],
    loading: false,
    error: null,
  },
  selectedIngredient: {
    data: {},
    loading: false,
  },
};
export const getIngredients = createAsyncThunk(
  "ingredients/getIngredients",
  async () => {
    try {
      const response = await httpClient.get("/web/ingrediens");
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);
export const addIngredient = createAsyncThunk(
  "ingredients/addIngredient",
  async (ingredient) => {
    try {
      const response = await httpClient.post("/web/ingrediens", ingredient);
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);
export const getIngredientById = createAsyncThunk(
  "ingredients/getIngredientById",
  async (id) => {
    try {
      const response = await httpClient.get(`/web/ingrediens/${id}`);
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const updateIngredient = createAsyncThunk(
  "ingredients/updateIngredient",
  async (ingredient) => {
    try {
      const response = await httpClient.put(
        `/web/ingrediens/${ingredient._id}`,
        ingredient?.data
      );
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const deleteIngredient = createAsyncThunk(
  "ingredients/deleteIngredient",
  async (id) => {
    try {
      await httpClient.delete(`/web/ingrediens/${id}`);
      return id;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    initiSelectedIngredien: (state) => {
      state.selectedIngredient = {
        data: {},
        loading: false,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getIngredients.pending, (state) => {
        state.ingredients.loading = true;
      })
      .addCase(getIngredients.fulfilled, (state, action) => {
        state.ingredients.loading = false;
        state.ingredients.data = action.payload;
      })
      .addCase(getIngredients.rejected, (state, action) => {
        state.ingredients.loading = false;
        state.ingredients.error = action.error.message;
      })
      .addCase(addIngredient.pending, (state) => {
        state.selectedIngredient.loading = true;
      })
      .addCase(addIngredient.fulfilled, (state, action) => {
        state.selectedIngredient.loading = false;
        state.selectedIngredient.data = action.payload;
      })
      .addCase(addIngredient.rejected, (state, action) => {
        state.selectedIngredient.loading = false;
        state.selectedIngredient.error = action.error.message;
      })
      .addCase(getIngredientById.pending, (state) => {
        state.selectedIngredient.loading = true;
      })
      .addCase(getIngredientById.fulfilled, (state, action) => {
        state.selectedIngredient.loading = false;
        state.selectedIngredient.data = action.payload;
      })
      .addCase(getIngredientById.rejected, (state, action) => {
        state.selectedIngredient.loading = false;
        state.selectedIngredient.error = action.error.message;
      })
      .addCase(updateIngredient.pending, (state) => {
        state.ingredients.loading = true;
      })
      .addCase(updateIngredient.fulfilled, (state, action) => {
        state.ingredients.loading = false;
        state.ingredients.data = state.ingredients.data.map((ingredient) =>
          ingredient._id === action.payload._id ? action.payload : ingredient
        );
      })
      .addCase(updateIngredient.rejected, (state, action) => {
        state.ingredients.loading = false;
        state.ingredients.error = action.error.message;
      })
      .addCase(deleteIngredient.pending, (state) => {
        state.ingredients.loading = true;
      })
      .addCase(deleteIngredient.fulfilled, (state, action) => {
        state.ingredients.loading = false;
        state.ingredients.data = state.ingredients.data.filter(
          (ingredient) => ingredient._id !== action.payload
        );
      })
      .addCase(deleteIngredient.rejected, (state, action) => {
        state.ingredients.loading = false;
        state.ingredients.error = action.error.message;
      });
  },
});

export const { initiSelectedIngredien } = categoriesSlice.actions;

export default categoriesSlice.reducer;
